<!--
  收货地址
  lovi 2020-06-30
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('personal.shippingAddress')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span slot="right" class="text-blue" @click="addressFlag = true">
        {{ $t("personal.newAddress") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <scroll>
        <van-empty
          v-if="!address.length && getListFlag"
          :image="
            require('@/assets/images/personal/not_deliver_address@2x.png')
          "
          :description="$t('personal.noAddressTips')"
        />
        <div class="address">
          <div
            class="item"
            v-for="(item, index) in address"
            :key="index"
            @click="getAddressInfo(item)"
          >
            <div class="info">
              <h3>{{ item.address }}</h3>
              <p>{{ item.house_number }}</p>
              <p>
                {{ item.name }}({{
                  item.sex == 1
                    ? $t("common.Mr")
                    : item.sex == 2
                    ? $t("common.Ms")
                    : ""
                }})
                <span class="phone">{{ _phoneFormat(item.mobile) }}</span>
              </p>
            </div>
            <i class="icon-edit" @click="toDetail(item.id)"></i>
          </div>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <address-manage
        v-if="addressFlag"
        :addressFlag.sync="addressFlag"
        :id.sync="id"
        :detail="detail"
        @getAddressList="getAddressList"
      />
    </transition>
  </div>
</template>

<script>
import AddressManage from "./address";
export default {
  props: ["addressListFlag", "addressInfo", "shopId"],
  meta: {
    service: false // 客服
  },
  name: "deliveryAddress",
  components: {
    AddressManage
  },
  data() {
    return {
      id: "",
      address: [],
      addressFlag: false,
      getListFlag: false,
      detail: {}
    };
  },
  created() {
    this.getAddressList();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      if (this.addressListFlag) {
        this.$emit("update:addressListFlag", false);
        this.$emit("getAddressList");
      } else {
        this._back();
      }
    },
    getAddressInfo(data) {
      // 获取地址信息
      let vm = this;
      if (vm.shopId) {
        vm.checkAddress(data);
      }
    },
    checkAddress(data) {
      // 检查配送地址范围
      let vm = this;
      let params = {};
      params.address_id = data.id;
      params.shop_id = vm.shopId;
      vm.$post("/app/shoppingcat/checkAddress", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("checkAddress", res);
        if (res.code == 0) {
          vm.$emit("update:addressListFlag", false);
          vm.$emit("getAddressInfo", data);
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    toDetail(id) {
      // 获取地址详情
      let vm = this;
      let params = {};
      params.id = id;
      vm.$post("/app/user/addressDetails", params, { loading: true }).then(
        res => {
          console.log("addressDetails", res);
          vm.detail = res;
          vm.id = id;
          vm.addressFlag = true;
        }
      );
    },
    getAddressList() {
      // 获取地址列表
      let vm = this;
      vm.getListFlag = false;
      vm.$post("/app/user/address", {}, { loading: true }).then(res => {
        vm.getListFlag = true;
        console.log("address", res);
        vm.address = res.data;
      });
    }
  },
  watch: {}
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
/deep/.van-empty {
  .van-empty__image {
    width: 240px;
    height: 150px;
  }
  .van-empty__description {
    font-size: 12px;
  }
}
.address {
  padding: 5px 15px;
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    line-height: 1.2;
    border-bottom: 1.1px solid #e9e9e9;
    .info {
      flex: 1;
      overflow: hidden;
      h3 {
        font-size: 14px;
        font-weight: 400;
      }
      p {
        margin-top: 5px;
      }
      .phone {
        margin-left: 5px;
      }
    }
    .icon-edit {
      width: 20px;
      height: 20px;
      background: url("@{images}public/icon_edit@2x.png") no-repeat;
      background-size: 100%;
    }
  }
}
</style>
